function* domIdentitiesIterator(domIdentities) {
  for (let i = 0; i < domIdentities.length; i += 6) {
    yield {
      bottom: domIdentities[i + 4],
      identity: domIdentities[i],
      left: domIdentities[i + 5],
      parentIndex: domIdentities[i + 1],
      right: domIdentities[i + 3],
      top: domIdentities[i + 2]
    };
  }
}
function* domIdentitiesReverseIterator(domIdentities) {
  for (let i = domIdentities.length - 6; i >= 0; i -= 6) {
    yield {
      bottom: domIdentities[i + 4],
      identity: domIdentities[i],
      left: domIdentities[i + 5],
      parentIndex: domIdentities[i + 1],
      right: domIdentities[i + 3],
      top: domIdentities[i + 2]
    };
  }
}
export {
  domIdentitiesIterator,
  domIdentitiesReverseIterator
};
//# sourceMappingURL=iterators.js.map
